import { apiFetch } from '../admin/jscontrol/apiClient';

const storefrontOptions = { useStorefrontAuth: true };

export async function confirmOrderFromCartApi(payload) {
  const { data } = await apiFetch('/Order/ConfirmFromCart', {
    method: 'POST',
    ...storefrontOptions,
    data: payload,
  });
  if (data?.success === false) throw new Error(data?.message || 'Could not confirm order.');
  return data?.data ?? data;
}

export async function fetchOrders(params = {}) {
  const qs = new URLSearchParams({
    pageIndex: String(params.pageIndex ?? 1),
    pageSize: String(params.pageSize ?? 10),
    search: params.search ?? '',
    sortColumn: params.sortColumn ?? 'OrderedAt',
    sortBy: (params.sortBy ?? 'DESC').toUpperCase(),
  });
  if (params.userId) qs.set('userId', String(params.userId));

  const { data } = await apiFetch(`/Order/GetAll?${qs}`, params.useStorefront ? storefrontOptions : undefined);
  return {
    items: Array.isArray(data?.data) ? data.data : [],
    totalRecords: data?.totalRecords ?? 0,
  };
}

export async function fetchMyOrders(userId, pageSize = 50) {
  return fetchOrders({
    userId,
    pageIndex: 1,
    pageSize,
    sortColumn: 'OrderedAt',
    sortBy: 'DESC',
    useStorefront: true,
  });
}

export async function fetchOrderById(orderId, useStorefront = false) {
  const { data } = await apiFetch(
    `/Order/GetById/${orderId}`,
    useStorefront ? storefrontOptions : undefined
  );
  if (data?.success === false) throw new Error(data?.message || 'Order not found.');
  return data?.data ?? data;
}

export async function createOrderApi(payload) {
  const { data } = await apiFetch('/Order/Create', { method: 'POST', data: payload });
  if (data?.success === false) throw new Error(data?.message || 'Could not create order.');
  return data?.data?.OrderId ?? data?.data?.orderId ?? null;
}

export async function updateOrderApi(payload) {
  const { data } = await apiFetch('/Order/Update', { method: 'PUT', data: payload });
  if (data?.success === false) throw new Error(data?.message || 'Could not update order.');
}

export async function deleteOrderApi(orderId) {
  const { data } = await apiFetch(`/Order/Delete/${orderId}`, { method: 'DELETE' });
  if (data?.success === false) throw new Error(data?.message || 'Could not delete order.');
}
